import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

/**
 * Chip styling variant for combined rent status.
 * @returns {'notConfigured'|'good'|'poor'}
 */
export function getCombinedRentStatusVariant(rentConfigured, rentStatus) {
  if (rentConfigured !== true) {
    return 'notConfigured';
  }
  if (rentStatus === 'goodStanding') {
    return 'good';
  }
  if (rentStatus === 'poorStanding') {
    return 'poor';
  }
  return 'notConfigured';
}

/**
 * Plain label for combined "Rent Status" (CSV / non-chip).
 * @returns {'Not configured'|'Good'|'Poor'}
 */
export function getCombinedRentStatusLabel(rentConfigured, rentStatus) {
  if (rentConfigured !== true) {
    return 'Not configured';
  }
  if (rentStatus === 'goodStanding') {
    return 'Good';
  }
  if (rentStatus === 'poorStanding') {
    return 'Poor';
  }
  return 'Not configured';
}

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  border: 1px solid ${({ $border }) => $border};
  color: ${({ $color }) => $color};
  background-color: ${({ $bg }) => $bg};
`;

const VARIANT_THEME = {
  good: {
    color: '#2E7D32',
    background: '#E8F5E9',
    border: '#2E7D32'
  },
  notConfigured: {
    color: '#616161',
    background: '#F5F5F5',
    border: '#9E9E9E'
  },
  poor: {
    color: '#D84315',
    background: '#FFEBEE',
    border: '#D84315'
  }
};

/**
 * Combined rent status pill: Not configured | Good | Poor (see admin rent VoPay fields).
 */
const RentStatusChip = ({ rentConfigured, rentStatus }) => {
  const { t } = useTranslation();
  const variant = getCombinedRentStatusVariant(rentConfigured, rentStatus);
  const theme = VARIANT_THEME[variant];

  const label =
    variant === 'notConfigured'
      ? t('Not configured')
      : variant === 'good'
        ? t('Good')
        : t('Poor');

  return (
    <Chip $color={theme.color} $bg={theme.background} $border={theme.border}>
      {label}
    </Chip>
  );
};

export default RentStatusChip;
